export const propFaqBooking = {
  faqEditor: {
    empty: "لا توجد أسئلة بعد. أضف السؤال الأول ليتمكّن الوكيل من الإجابة عليه.",
    learnedTooltip: "إجابة مُضافة عبر التعلّم الذاتي من المضيف",
    learnedBadge: "مُتعلَّمة",
    removeAttachment: "إزالة المرفق",
    uploading: "جارٍ الرفع…",
    attach: "إرفاق",
    deleteTooltip: "حذف",
    addQuestion: "إضافة سؤال",
    qPlaceholder: "السؤال · مثال: هل يتوفّر موقف سيارات؟",
    aPlaceholder: "الإجابة · مثال: نعم، مجاني أمام الباب.",
    errors: {
      fillBeforeAttach: "اكتب السؤال والإجابة قبل إرفاق الملفات.",
      saveBeforeAttach: "احفظ أولاً لتتمكّن من إرفاق الملفات.",
      uploadFailed: "تعذّر رفع الملف.",
      deleteFailed: "تعذّر حذف الملف.",
    },
  },
  faqSuggestions: {
    title: "اقتراحات للتعلّم",
    intro: "لم يستطع الوكيل الإجابة على هذه الأسئلة وقمت بالرد على الضيف. راجعها وعدّلها إذا لزم الأمر واحفظها ليجيب عليها الوكيل بنفسه من الآن فصاعدًا.",
    askedLabel: "سأل الضيف",
    questionLabel: "السؤال",
    questionPlaceholder: "كيف تصوغ السؤال؟",
    answerLabel: "إجابة الوكيل",
    answerPlaceholder: "الإجابة التي سيقدّمها الوكيل",
    applyToOthers: "طبّق أيضًا على وحدات أخرى في الإعلان:",
    dismiss: "تجاهل",
    saveAsAnswer: "حفظ كإجابة",
    errors: {
      saveFailed: "تعذّر الحفظ.",
      dismissFailed: "تعذّر التجاهل.",
    },
  },
  sourceNote: {
    title: "ترتيب أولوية إجابات الوكيل",
    infoAria: "عرض ترتيب أولوية مصادر الوكيل",
    lead: "عندما يقول مصدران أمرًا مختلفًا عن البيان نفسه، يتّبع الوكيل هذا الترتيب:",
    faqPre: "الأسئلة الشائعة ",
    faqStrong: "لكل وحدة على حدة",
    faqTag: "الأولوية",
    configMain: "إعدادات مكان الإقامة",
    configMuted: "· المواعيد، السعة، الخدمات",
    kb: "قاعدة المعرفة",
  },
  bookingLinks: {
    title: "كيف يحجز الضيف",
    subPre: "يرسل الوكيل رابط ",
    subStrong: "الحجوزات المباشرة",
    subPost: " الخاص بك ويحجز الضيف عبر الويب.",
    step1Pre: "إذا حدّد ",
    step1Strong: "مكان إقامة معيّنًا",
    step1Post: "، يرسل الوكيل رابطه المباشر.",
    step2Pre: "إذا كان هناك ",
    step2Strong1: "عدة أماكن في تلك المنطقة",
    step2Mid: "، فإنه ",
    step2Strong2: "يسرد كل واحد مع رابطه",
    step2Post: " بالإضافة إلى الرابط العام.",
    step3Pre: "إذا لم يعرف المنطقة، فإنه ",
    step3Strong: "يقترح المناطق المتاحة",
    step3Post: " ويسأل الضيف أين يرغب.",
    globalLinkLabel: "الرابط العام (جميع المواقع)",
    copy: "نسخ",
    copied: "تم النسخ",
    noIdNote: "سيُنشأ رابط الحجوزات عندما يكون لحسابك المعرّف مُهيّأً.",
    toastCopied: "تم نسخ الرابط",
    toastCopyFailed: "تعذّر النسخ",
  },
  bookingConfirm: {
    title: "الإشعار بحجز جديد",
    subPre: "عند تأكيد الحجز، نُشعِر الضيف تلقائيًا ",
    subStrong: "عبر واتساب",
    subPost: " ببيانات إقامته.",
    toggleLabel: "إرسال التأكيد عبر واتساب",
    toggleHint: "إذا ألغيت التفعيل، فلن يُرسَل هذا الإشعار إلى الضيف. وإذا وصل الحجز عبر وكالة سفر عبر الإنترنت (OTA)، فستتولّى الوكالة إشعاره.",
    stateOn: "نعم، أرسِل",
    stateOff: "لا ترسل",
    notEditablePre: "في الوقت الحالي، محتوى هذه الرسالة ",
    notEditableStrong: "غير قابل للتعديل",
    notEditablePost: ". نعرض لك معاينة لما يستلمه الضيف.",
    previewTag: "معاينة · ما يراه الضيف",
    online: "متصل الآن",
    today: "اليوم",
    previewHint: "يتحدّث وفقًا لإعداداتك",
    defaultListingName: "مكان الإقامة",
    toastEnabled: "تم تفعيل إشعار الحجز",
    toastDisabled: "تم إلغاء تفعيل إشعار الحجز",
    toastSaveFailed: "تعذّر حفظ التغيير",
    previewGuest: "Laura García",
    previewBody: "مرحبًا *{guest}* 👋\n\nحجزك في *{name}* مؤكَّد ✅\n\nرمز الحجز: *6233Q1VC5*\nالتواريخ: *05/06/2026* – *07/06/2026* 📅\n\nعبر واتساب هذا يمكنك طلب رابط تسجيل الوصول عبر الإنترنت، وكذلك استلام تعليمات الوصول.\nإذا احتجت إلى مساعدة قبل الإقامة أو خلالها، راسِلنا هنا 💬",
    previewCta: "🇪🇸 لمتابعة تسجيل الوصول، اضغط زر *Ok* أو اكتب *Ok*.",
  },
};
